<script>
import useLoading from '@/helpers/loading-effect';
import {onMounted, onUnmounted, watch} from 'vue';
import {WorkflowsRepository} from '@/services/workflows-repository';
import {onBeforeRouteLeave, useRoute} from 'vue-router';
import {useStore} from '@/helpers/store-effect';
import WorkflowEditorCanvas from '@/components/workflows/WorkflowEditorCanvas';
import useNotifications from "@/helpers/notify-effect";

export default {
  name: 'WorkflowEditor',
  template: '#workflow-editor-template',
  components: {
    WorkflowEditorCanvas,
  },
  props: {
    uid: {
      type: String,
      required: true,
    },
    nodeUid: {type: String},
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const {notify} = useNotifications();

    let originalWorkflow = null;

    const {
      isLoading,
      isLoaded,
      startLoading,
      stopLoading,
    } = useLoading();

    const getFromBackend = async (uid) => {
      startLoading();
      store.workflow = await WorkflowsRepository.getWorkflow(uid);
      stopLoading();
    };

    const getFromStore = () => {
      startLoading();
      if (store.workflow.new) {
        save();
      }
      stopLoading();
    };

    const {
      isLoading: isSaving,
      isLoaded: isSaved,
      startLoading: startSaving,
      stopLoading: stopSaving,
    } = useLoading('');

    const save = async () => {
      startSaving();
      if (store.workflow.new) {
        await WorkflowsRepository.createWorkflow(store.workflow);
        store.workflow.new = false;
        notify('Workflow created', 'Your changes to this workflow has been saved.', 'success')
      } else {
        await WorkflowsRepository.updateWorkflow(store.workflow);
        notify('Workflow updated', 'Your changes to this workflow has been saved.', 'success')
      }
      originalWorkflow = store.workflow?.copy();
      stopSaving();
    };

    const retrieve = async () => {
      if (store.workflow) {
        getFromStore();
      } else if (route.params.uid) {
        await getFromBackend(route.params.uid);
      }

      originalWorkflow = store.workflow?.copy();
    };

    onMounted(retrieve);
    watch(() => route.params.uid, () => route.params.uid && retrieve());

    // Confirmation
    const confirmChanges = () => {
      if (!originalWorkflow.isIdenticalTo(store.workflow)) {
        return 'Do you really want to leave? you have unsaved changes!';
      }
    };
    onBeforeRouteLeave(() => {
      const message = confirmChanges();
      return message ? confirm(message) : true;
    });
    window.onbeforeunload = function () {
      return confirmChanges();
    };

    onUnmounted(() => {
      store.workflow = null;
      window.onbeforeunload = null;
    });

    return {
      isLoaded,
      isLoading,
      isSaving,
      isSaved,
      get workflow() {
        return store.workflow;
      },
      get lastEnabledState(){
        return originalWorkflow?.enabled || store.workflow?.enabled;
      },
      save,
      get currentActiveNodes() {
        return store.currentActiveNodes;
      },
    };
  },
};
</script>
